(function ($) {


    this.init = function () {
        this.GlobalNavigation();
        this.DesktopSearch();
        this.MobileSearch();
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.GlobalNavigation = function () {
        // Global Navigation - when a user selects one of the top links, let's just add the "globalnavselected" class to it
        // as well as remove that class from all others
        $(".globalheader-content-sectionnav a").on("click", onClickGlobalNavigationLink);
    }
    this.DesktopSearch = function () {

        var Form = $(".globalheader-content-global-search form");
        var Input = $(".globalheader-content-global-search form input[type='text']");
        var Button = $(".globalheader-content-global-search form button[type='submit']");

        $("body").click(function () {
            Form.removeClass("active");
        });

        Form.click(function (e) {
            e.stopPropagation();
        });

        Input.focus(function (e) {
            Form.addClass("active");
        });

        Button.click(function (e) {
            if (Form.hasClass("active") == false || Input.val() == "") {
                e.preventDefault();
                Form.addClass("active");
                Input.focus();
            }
        });
    }
    this.MobileSearch = function () {

        var Form = $(".mobilenav-content-right-search form");
        var Input = $(".mobilenav-content-right-search form input[type='text']");
        var Button = $(".mobilenav-content-right-search form button[type='submit']");

        $("body").click(function () {
            Form.removeClass("active");
        });

        Form.click(function (e) {
            e.stopPropagation();
        });

        Input.focus(function (e) {
            Form.addClass("active");
        });

        Button.click(function (e) {
            if (Form.hasClass("active") == false || Input.val() == "") {
                e.preventDefault();
                Form.addClass("active");
                Input.focus();
            }
        });
    }

    function onClickGlobalNavigationLink(event) {
        $(".globalheader-content-sectionnav a").removeClass("globalnavselected");
        $(event.currentTarget).addClass("globalnavselected");
    }

    this.init();

})(jQuery);